import { EditorImagesIds, TextColor } from '@setvi/shared/enums';
import { v4 as uuid } from 'uuid';
import moment from 'moment';
import {
  selectedProductClassName,
  selectedProductLinkClassName,
  selectedProductTitleClassName
} from './index';
import { EditorProduct } from '../../interfaces';

export const getProductCardAsHtml = (
  product: EditorProduct,
  manufacturer: boolean
) => {
  const imageWidth = 'width: 68px; min-width: 68px;';
  const imageHeight = 'height: 68px; min-height:68px;';
  const fontSize = '14px';
  const textFieldOverflow = `display: -webkit-box; overflow: hidden; text-overflow: ellipsis; -webkit-box-orient: vertical; -webkit-line-clamp: 2; word-break: break-word; line-height: 1.1; font-size: ${fontSize};`;
  const productName = `${textFieldOverflow} margin: auto 0; height: min-content; align-self: center; font-weight: 600; cursor: pointer;`;
  // @ts-ignore
  const productLink = product?.custom?.ecommerceLink?.value;
  const hasPrice = typeof product?.price === 'number';
  const showManufacturer = !!product?.manufacturerSku || !!product?.vendorName;

  // This encodeURI method is used for replacing spaces with %20 in the image URL to aviod the image not found issue
  const imageSrc = encodeURI(
    product.imageUrl || ''
    // 'https://euhd1msp.blob.core.windows.net/public/no-product-image.png'
  );
  const productImage = imageSrc
    ? ` <div style="${imageWidth} ${imageHeight} border-radius: 2px; overflow: hidden; display: flex">
          <img id="${EditorImagesIds.PRODUCT}" src=${imageSrc} alt=${product.productName} style="object-fit: contain; max-width: 100%; max-height: 100%;  margin: auto 6px auto auto" />
        </div>`
    : '';

  return `<div id="product-${uuid()}" class="${selectedProductClassName}" style="min-width: 280px; max-width: 310px; border: 1px solid ${TextColor.LightGrey}; border-radius: 12px; padding: 12px 10px">
            <div>    
                <div style="display: flex;">
                    ${productImage}
                    ${
                      productLink
                        ? `<a class="${selectedProductLinkClassName}" data-product-href="${productLink}" contenteditable="false" target="_blank" style="${productName} color: #1E96FC;">
                            ${product?.productName}
                          </a>`
                        : `<p class="${selectedProductTitleClassName}" style="${productName} color: ${TextColor.Black};">${product.productName}</p>`
                    }
                </div>
                <p style="${textFieldOverflow} color: ${TextColor.Grey}; padding-top: 8px">
                  SKU: ${product.sku}
                </p>
            </div>
          <div style="padding: 8px 0 ${hasPrice ? '8px' : '0'} 0; border-top: 1px solid #E6E7E9; margin-top: 8px">
            ${
              showManufacturer
                ? `
              <p style="${textFieldOverflow} font-size: ${fontSize} color: ${TextColor.Black}">
                MFG: ${product?.vendorName || 'Not Available'}
              </p>
              ${!manufacturer && product?.manufacturerSku ? `<p style="font-size: ${fontSize}; color: ${TextColor.Grey}; padding-top: 6px">${product?.manufacturerSku}</p>` : ''}
              `
                : ''
            }
            
            ${
              product?.daysOverdue
                ? `<p style="${textFieldOverflow} font-size: ${fontSize}; color: ${TextColor.Black}">
                    Days Late: ${product.daysOverdue}
                  </p>`
                : ''
            }
            ${
              product?.expectedOrder
                ? `<p style="${textFieldOverflow} font-size: ${fontSize}; color: ${TextColor.Black}; margin: 4px 0">
                    Was due on: ${moment(product.expectedOrder).format('l')}
                  </p>`
                : ''
            }
            ${
              product?.expectedQty
                ? `<p style="${textFieldOverflow} font-size: ${fontSize}; color: ${TextColor.Black}">
                    Expected quantity: ${Math.round(product.expectedQty)}
                    </p>`
                : ''
            }
              </div>
            ${
              hasPrice
                ? `<p style="border-top: 1px solid #E6E7E9; padding-top: 8px; font-size: ${fontSize}; font-weight: 600">${manufacturer ? 'List:' : ''} ${(
                    product?.price || 0
                  ).toLocaleString('en-US', {
                    currency: 'USD',
                    style: 'currency'
                  })}</p>`
                : ''
            }
          </div>`;
};
